import { render, staticRenderFns } from "./TheScrollButton.vue?vue&type=template&id=2d5acca5&"
import script from "./TheScrollButton.vue?vue&type=script&lang=js&"
export * from "./TheScrollButton.vue?vue&type=script&lang=js&"
import style0 from "./TheScrollButton.vue?vue&type=style&index=0&id=2d5acca5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports